import { render, staticRenderFns } from "./SmsSendPopup.vue?vue&type=template&id=68084808&"
import script from "./SmsSendPopup.vue?vue&type=script&lang=js&"
export * from "./SmsSendPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports